"use client";

import { getImageURL, useSwiperSliderOptions } from "@/lib";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

export const PrimePageStepSection = ({ data = {}, slug = "prime_step" }) => {
    const { heading = "", process = [] } = data;

    const { options } = useSwiperSliderOptions({
        slidesPerView: 1,
        modules: [Pagination],
        spaceBetween: 40,
        slidesPerGroup: 1,
        loop: false,
        pagination: {
            el: ".how-work-swipper-pagination",
            clickable: true,
        },
        breakpoints: {
              1700: { 
                slidesPerView: 4,
                spaceBetween: 40,
               },
              1200: { 
                slidesPerView: 4,
                spaceBetween: 20,
               },
              1024: { 
                slidesPerView: 3,
                spaceBetween: 50,
               },
              768: { 
                slidesPerView: 2,
                spaceBetween: 50
              }
                ,
              480: { slidesPerView: 1 }
          }
    });

    return (
        <>
            <section className="steps__section" id={slug}>
                <div className="custom-container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10 col-xl-10 col-xxl-8">
                            <div className="section_header text-center">
                                <h3
                                    className="heading fs-48 fw-300"
                                    dangerouslySetInnerHTML={{
                                        __html: heading,
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-12 col-xl-12 col-xxl-12">
                            <div className="steps__wrapper">
                                <Swiper {...options} className="steps_slider">
                                    {Array.isArray(process) &&
                                        process.map((stepItem, idx) => (
                                            <SwiperSlide key={idx}>
                                                <div className="circle_wrapper">
                                                    <div
                                                        className="outer_cirle"
                                                        style={{
                                                            backgroundImage: `url(${getImageURL(
                                                                "/upload/media/circle_gradient_1755750996.webp"
                                                            )})`,
                                                            backgroundSize:
                                                                "cover",
                                                            backgroundPosition:
                                                                "50% 50%",
                                                            backgroundRepeat:
                                                                "no-repeat",
                                                        }}
                                                    >
                                                        <div className="inner_circle fs-28">
                                                            <h4
                                                                className="step_heading fs-28"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: stepItem?.step,
                                                                }}
                                                            />

                                                            <div className="content__wrap">
                                                                <p
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: stepItem?.heading,
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        ))}
                                    <div className="how-work-swipper-pagination" />
                                </Swiper>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
